import { authClient } from "@/modules/auth/presentation/api/client";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { useNavigate } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";

export function TwoFactorVerifyPage() {
  const navigate = useNavigate();
  const [code, setCode] = useState("");
  const [loading, setLoading] = useState(false);

  const verify = async () => {
    setLoading(true);
    try {
      const { error } = await authClient.twoFactor.verifyTotp({
        code: code.replace(/\D/g, ""),
        trustDevice: true,
      });
      if (error) {
        toast.error(error.message ?? "ລະຫັດບໍ່ຖືກຕ້ອງ");
        return;
      }
      toast.success("ເຂົ້າລະບົບສຳເລັດ");
      void navigate({ to: "/app/dashboard" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mx-auto w-full max-w-md">
      <CardHeader>
        <CardTitle>ຢືນຢັນ 2FA</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        <p className="text-muted-foreground text-sm">
          ປ້ອນລະຫັດ 6 ຫຼັກຈາກແອບ Authenticator
        </p>
        <Input
          inputMode="numeric"
          autoComplete="one-time-code"
          placeholder="123456"
          maxLength={6}
          value={code}
          onChange={(e) => setCode(e.target.value.replace(/\D/g, "").slice(0, 6))}
          onKeyDown={(e) => {
            if (e.key === "Enter") void verify();
          }}
        />
        <Button
          className="w-full"
          disabled={loading || code.length !== 6}
          onClick={() => void verify()}
        >
          {loading ? "ກຳລັງຢືນຢັນ..." : "ຢືນຢັນ"}
        </Button>
      </CardContent>
    </Card>
  );
}
